import { load } from '@ms/yammer-data/dist/domains/featureAccessInsights/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useFeatureAccessInsights, useFeatureAccessInsightsStatus } from './selectors';

type UseLoadFeatureAccessInsights = (props: { readonly selectedOnBehalfOfUserId?: string }) => void;
export const useLoadFeatureAccessInsights: UseLoadFeatureAccessInsights = ({ selectedOnBehalfOfUserId }) => {
  const dispatch = useDispatch();
  const featureAccessInsights = useFeatureAccessInsights();
  const status = useFeatureAccessInsightsStatus();

  useEffect(() => {
    const isFulfilledAndSameOnBehalfOfUserId =
      featureAccessInsights?.onBehalfOfUserId === selectedOnBehalfOfUserId && status === 'fulfilled';

    if (isFulfilledAndSameOnBehalfOfUserId || status === 'rejected') {
      return;
    }

    dispatch(load({ onBehalfOfUserId: selectedOnBehalfOfUserId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureAccessInsights?.onBehalfOfUserId, selectedOnBehalfOfUserId, status]);
};
